var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'loan-add'},"title":_vm.$t('menuitems.loan.text')}}),_c('List',{attrs:{"dataList":_vm.loanData,"edit":{link: 'loan-edit'},"more":{
          sub: [{
            name: 'loan.contract', link: 'property-view'
          }]
        },"filter":{
          search: ['loan.code', 'loan.customer'],
          dropdown: [],
          date: {
            title: 'general.date',
            field: 'loan.loan_date'
          }
        },"deletes":[_vm.deleted, null],"module":'loan',"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'currency_en'}, {name: 'loan_date', type: 'date'}, {name: 'expire_date', type: 'date'}, 
                  {name: 'amount', type: 'currency'}, {name: 'loan_amount', type: 'currency'}, {name: 'price', type: 'currency'}],"fields":[ ("code: " + (_vm.$t('loan.code'))), ("loan_date: " + (_vm.$t('general.date'))), ("customer: " + (_vm.$t('customer.text'))), 
          ("property: " + (_vm.$t('property.text'))), ("currency_en: " + (_vm.$t('loan.loan-type'))), ("currency_en: " + (_vm.$t('property.currency'))), 
          ("price: " + (_vm.$t('loan.amount'))), ("loan_amount: " + (_vm.$t('loan.paid-amount'))), ("amount: " + (_vm.$t('loan.balance-principle')))]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }